import styled, { css } from 'styled-components'

import { DateRangePicker } from '@avantstay/avantstay-ui'

import { Button } from '../../components/Button'
import { ellipsis } from '../../styles'
import { mainColors } from '../../styles/colors'
import { _M_Normal, _S_Normal, _XS_Medium } from '../../styles/typography'
import { rgba } from '../../utils'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const CustomDateRange = styled(DateRangePicker)<{ customSelectedColor?: string }>`
  .rdr-DateRange {
    align-items: center;
  }

  .rdr-DayWrapper {
    &.accentExtraLight {
      background-color: ${mainColors.accentExtraLight};
    }
  }

  .rdr-Day.is-selected {
    background-color: ${p => p.customSelectedColor} !important;
  }
`

export const SelectDateContainer = styled.div<{ isOpen: boolean }>`
  border: 2px solid #e9eef1;
  border-radius: 2px;
  display: flex;
  flex-wrap: wrap;
  min-height: 48px;
  width: 100%;
  padding: 10px 14px;
  gap: 6px;
  cursor: pointer;

  ${({ isOpen }) =>
    isOpen &&
    css`
      border: 2px solid ${mainColors.accentMedium};
    `}
`

export const DateOption = styled.div`
  ${_S_Normal};
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  background-color: ${mainColors.neutralMedium};
  border-radius: 2px;
`

export const RemoveButton = styled(Button.Flat)`
  color: ${mainColors.neutralExtraDark};

  svg {
    color: ${mainColors.neutralExtraDark};
  }
`

export const Root = styled.div`
  display: flex !important;
  gap: 20px;
  margin-top: 20px;
  flex-direction: row;
  flex-wrap: wrap;
`

export const LegendDotCell = styled.div`
  display: flex;
  flex-direction: row;
  width: auto;
  align-items: center;
  gap: 6px;
  color: ${mainColors.neutralExtremelyDark};
  ${_M_Normal};
`

export const LegendDot = styled.div<{ color: string; half?: boolean }>`
  background: ${p =>
    p.half ? `linear-gradient(-45deg, ${rgba(p.color, 1)} 50%, ${rgba(p.color, 0)} 50%)` : p.color};
  width: 10px;
  height: 10px;
  flex-grow: 0;
  flex-shrink: 0;
  border-radius: 5px;
  border: ${p => (p.half ? `1px solid ${p.color}` : '0')};
`

export const LegendLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  ${_XS_Medium};
  ${ellipsis};
  color: ${mainColors.neutralExtremelyDark};
`

export const LegendValue = styled.div`
  margin-left: 16px;
  ${_M_Normal};
  color: ${mainColors.black};
`
